import { Card } from "@/components/ui/card";

export default function TermsOfService() {
  return (
    <div className="min-h-screen pt-24 pb-12 px-6">
      <div className="max-w-3xl mx-auto">
        <Card className="p-8">
          <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
          <p className="text-muted-foreground mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>
          
          <div className="space-y-6 text-muted-foreground">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing or using Bodyz Gym, you agree to be bound by these Terms of Service. 
                If you disagree with any part of the terms, you may not access the service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">2. Description of Service</h2>
              <p>
                Bodyz Gym is an AI-powered fitness application that provides personalized training 
                plans, exercise libraries, and progress tracking tools. The service is provided 
                by Jacaobtech Labs.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">3. User Accounts</h2>
              <p className="mb-2">When you create an account with us, you must provide accurate and complete information. You are responsible for:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized access</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">4. Medical Disclaimer</h2>
              <p>
                Bodyz Gym is not a medical service. Always consult with a healthcare provider 
                before starting any new exercise program. Stop exercising immediately if you 
                experience pain, dizziness, or shortness of breath.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">5. User Content</h2>
              <p>
                You retain ownership of any content you submit to the service. By submitting content, 
                you grant us a license to use, modify, and display that content for the purpose of 
                providing and improving our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">6. Prohibited Activities</h2>
              <p className="mb-2">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Use the service for any illegal purpose</li>
                <li>Attempt to gain unauthorized access to any part of the service</li>
                <li>Interfere with or disrupt the service or servers</li>
                <li>Share your account credentials with others</li>
                <li>Use the service to harass, abuse, or harm others</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">7. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Jacaobtech Labs shall not be liable 
                for any indirect, incidental, special, consequential, or punitive damages resulting 
                from your use of or inability to use the service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">8. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. We will notify users 
                of any changes by updating the date at the top of this page.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">9. Contact Information</h2>
              <p>
                For any questions about these Terms of Service, please contact us at 
                support@bodyz-gym.com.
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
}
